import { render, staticRenderFns } from "./forex-trading-view.vue?vue&type=template&id=1a0f2665&scoped=true"
import script from "./forex-trading-view.vue?vue&type=script&lang=js"
export * from "./forex-trading-view.vue?vue&type=script&lang=js"
import style0 from "./forex-trading-view.vue?vue&type=style&index=0&id=1a0f2665&prod&lang=css"
import style1 from "./forex-trading-view.vue?vue&type=style&index=1&id=1a0f2665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0f2665",
  null
  
)

export default component.exports